import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/product_symbol.svg'
import _imports_1 from '../../assets/workforce.svg'
import _imports_2 from '../../assets/navbar-icons/home.svg'
import _imports_3 from '../../assets/navbar-icons/home-normal.svg'
import _imports_4 from '../../assets/svgs/jobs_hover.svg'
import _imports_5 from '../../assets/svgs/jobs.svg'
import _imports_6 from '../../assets/navbar-icons/filled-person.svg'
import _imports_7 from '../../assets/navbar-icons/user.svg'
import _imports_8 from '../../assets/svgs/results-black.svg'
import _imports_9 from '../../assets/svgs/results.svg'
import _imports_10 from '../../assets/navbar-icons/bell.svg'
import _imports_11 from '../../assets/navbar-icons/bell-gray.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "sm:flex flex-row items-center justify-between py-4" }
const _hoisted_3 = { class: "sm:flex flex-row w-full lg:justify-start justify-end" }
const _hoisted_4 = { class: "flex flex-row items-center lg:justify-start justify-between w-full" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_6 = { class: "relative inline-block text-left text-black" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "pl-5 text-sm font-bold" }, "Talent Sourcing", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "pl-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 9l-7 7-7-7"
    })
  ])
], -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "origin-top-right absolute right-0 w-64 rounded-2xl shadow-2xl text-sm overflow-hidden z-20"
}
const _hoisted_12 = {
  class: "rounded-md bg-white w-full px-2 py-2",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "p-4 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-end" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex justify-end items-end text-white" }, [
        /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col pl-3 py-1" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mt-2" }, "Workforce Solutions")
      ])
    ])
  ])
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "pl-5 text-sm font-bold" }, "Talent Sourcing", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "lg:pl-16 hidden lg:block" }
const _hoisted_20 = { class: "flex flex-row space-x-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "p-2"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mx-auto" }, "Home", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "p-2"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mx-auto text-gray-400" }, "Home", -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "p-2"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mx-auto" }, "Jobs", -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "p-2"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mx-auto text-gray-400" }, "Jobs", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "p-2 -mt-1.5"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mx-auto" }, "Candidates", -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "p-2 -mt-1.5"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mx-auto text-gray-400" }, "Candidates", -1)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  width: "37",
  class: "p-2 text-black"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mx-auto" }, "Talent Evaluations", -1)
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  width: "37",
  class: "p-2"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mx-auto text-gray-400" }, "Talent Evaluations", -1)
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  class: "p-2",
  width: "37"
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mx-auto" }, "Notifications", -1)
const _hoisted_47 = { class: "flex flex-col justify-center items-center ml-2 rounded-lg px-1 py-1 text-xs font-normal text-white bg-pink-600" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  class: "p-2",
  width: "37"
}, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mx-auto text-gray-400 px-2" }, "Notifications", -1)
const _hoisted_50 = { class: "flex flex-col justify-center items-center -ml-1 rounded-lg p-1 text-xs font-normal text-white bg-gray-400" }
const _hoisted_51 = { class: "flex visible lg:hidden justify-end items-end" }
const _hoisted_52 = { class: "flex flex-row space-x-3 items-center" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6 text-primary",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M13.73 21a2 2 0 0 1-3.46 0" })
  ])
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-8 w-8 text-primary",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 6h16M4 12h16m-7 6h7"
  })
], -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  key: 0,
  class: "p-3 bg-white absolute shadow-menu right-6 w-2/3 md:w-1/3 rounded-lg z-50"
}
const _hoisted_57 = { class: "space-y-1" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 mr-2",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
  })
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Home", -1)
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-6 w-6 mr-2\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\"></path><rect x=\"3\" y=\"7\" width=\"18\" height=\"13\" rx=\"2\"></rect><path d=\"M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2\"></path><line x1=\"12\" y1=\"12\" x2=\"12\" y2=\"12.01\"></line><path d=\"M3 13a20 20 0 0 0 18 0\"></path></svg><span class=\"text-sm\">Jobs</span>", 2)
const _hoisted_63 = [
  _hoisted_61
]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 mr-2",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
  })
], -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Candidates", -1)
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-6 w-6 mr-2\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\"></path><path d=\"M9 5H7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2V7a2 2 0 0 0 -2 -2h-2\"></path><rect x=\"9\" y=\"3\" width=\"6\" height=\"4\" rx=\"2\"></rect></svg><span class=\"text-sm\">Talent Evaluations</span>", 2)
const _hoisted_69 = [
  _hoisted_67
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.roles?.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives(_createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "flex flex-row items-center",
                      id: "options-menu",
                      "aria-haspopup": "true",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen))
                    }, _hoisted_10),
                    _createVNode(_Transition, {
                      "enter-active-class": "transition ease-out duration-500",
                      "enter-class": "transform opacity-0 scale-95",
                      "enter-to-class": "transform opacity-100 scale-100",
                      "leave-active-class": "transition ease-in duration-75",
                      "leave-class": "transform opacity-100 scale-100",
                      "leave-to-class": "transform opacity-0 scale-95"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isMenuOpen)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", {
                                  class: "cursor-pointer",
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePlatform && _ctx.changePlatform(...args)))
                                }, _hoisted_14)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ], 512), [
                  [_directive_click_away, _ctx.closeMenu]
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("button", {
                  class: "flex flex-row items-center",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/')))
                }, _hoisted_18)
              ])),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: _normalizeClass(["px-2 rounded-lg flex flex-row justify-center space-y-1", { 'bg-gray-100': _ctx.$route.name === 'Home' }])
              }, [
                (_ctx.$route.name === 'Home')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/'))),
                      class: "flex flex-row justify-start items-center"
                    }, _hoisted_23))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/'))),
                      class: "flex flex-row justify-start items-center"
                    }, _hoisted_26))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["px-2 rounded-lg flex flex-row justify-center space-y-1", { 'bg-gray-100': _ctx.$route.name === 'Jobs' }])
              }, [
                (_ctx.$route.name === 'Jobs')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/jobs'))),
                      class: "flex flex-row justify-start items-center"
                    }, _hoisted_29))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/jobs'))),
                      class: "flex flex-row justify-start items-center"
                    }, _hoisted_32))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["px-2 rounded-lg flex flex-row justify-center space-y-1", { 'bg-gray-100': _ctx.$route.name === 'Candidates' }])
              }, [
                (_ctx.$route.name === 'Candidates')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/candidates'))),
                      class: "flex flex-row justify-start items-center"
                    }, _hoisted_35))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/candidates'))),
                      class: "flex flex-row justify-start items-center"
                    }, _hoisted_38))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["px-2 rounded-lg flex flex-row justify-center space-y-1", { 'bg-gray-100': _ctx.$route.name === 'Talent Evaluation' }])
              }, [
                (_ctx.$route.name === 'Talent Evaluation')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/talent-evaluation'))),
                      class: "flex flex-row justify-start items-center"
                    }, _hoisted_41))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push('/talent-evaluation'))),
                      class: "flex flex-row justify-start items-center"
                    }, _hoisted_44))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["px-2 rounded-lg flex flex-row justify-center space-y-1", { 'bg-gray-100': _ctx.$route.name === 'Notifications' }])
              }, [
                (_ctx.$route.name === 'Notifications')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push('/notifications'))),
                      class: "flex flex-row justify-start items-center"
                    }, [
                      _hoisted_45,
                      _hoisted_46,
                      _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.notifications), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push('/notifications'))),
                      class: "flex flex-row justify-start items-center"
                    }, [
                      _hoisted_48,
                      _hoisted_49,
                      _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.notifications), 1)
                    ]))
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("span", {
                class: "relative",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push('/notifications')))
              }, [
                _hoisted_53,
                _createElementVNode("span", {
                  class: _normalizeClass(["border-2 border-white rounded-full h-3 w-3 text-xs absolute flex items-center -top-1 right-0 text-white", [
                    _ctx.notifications > 0 ? ' bg-green-600' : ' bg-pink-600',
                  ]])
                }, null, 2)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: "w-full",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isMenuOpenMobile = !_ctx.isMenuOpenMobile))
                }, _hoisted_55),
                (_ctx.isMenuOpenMobile)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _createElementVNode("ul", _hoisted_57, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["flex flex-row justify-start items-center rounded-sm p-2", {
                        'bg-primary-light text-primary': _ctx.$route.name === 'Home',
                      }]),
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$router.push('/')))
                        }, _hoisted_60, 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["flex flex-row justify-start items-center rounded-sm p-2", {
                        'bg-primary-light text-primary': _ctx.$route.name === 'Jobs',
                      }]),
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$router.push('/jobs')))
                        }, _hoisted_63, 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["flex flex-row justify-start items-center rounded-sm p-2", {
                        'bg-primary-light text-primary':
                          _ctx.$route.name === 'Candidates',
                      }]),
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$router.push('/candidates')))
                        }, _hoisted_66, 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["flex flex-row justify-start items-center rounded-sm p-2", {
                        'bg-primary-light text-primary':
                          _ctx.$route.name === 'Talent Evaluation',
                      }]),
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$router.push('/talent-evaluation')))
                        }, _hoisted_69, 2)
                      ])
                    ], 512)), [
                      [_directive_click_away, _ctx.closeMenuMobile]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}